module.exports = __webpack_public_path__ + "media/assets/icons/icon_review-087e4418d5e2bc8d967ec276b3554bc8.svg";